module.exports = __webpack_public_path__ + "img/thumbnail_AmericanBison_f_normal.2835fae6.png";